import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { MessageSquare, CheckCircle2 } from 'lucide-react';
const testimonials = [{
  quote: 'Pasé de no poder pedir pizza por teléfono a invitar a salir a la chica que me gustaba en 3 semanas. Los scripts de 3 segundos salvaron mi vida social.',
  name: 'Mateo G.',
  age: 21,
  location: 'Ciudad de México',
  result: '0 ataques de pánico en 1 mes'
}, {
  quote: "Pensé que era 'tímida de nacimiento'. Con Social Hacker entendí que era solo un hábito. Ayer di una presentación en la U y por primera vez no me temblaron las manos.",
  name: 'Valentina R.',
  age: 19,
  location: 'Bogotá, Colombia',
  result: 'Invitada a liderar su grupo de estudio'
}, {
  quote: "El bonus de 'Emergency Calm' es oro puro. Lo escucho antes de entrar a fiestas y mi ansiedad baja de 10 a 2 en minutos.",
  name: 'Lucas S.',
  age: 22,
  location: 'Buenos Aires, Argentina',
  result: 'Su primer grupo de amigos real en años'
}];
export function TestimonialsSection() {
  return <SectionWrapper data-id="element-286">
      <div className="text-center mb-16" data-id="element-287">
        <h2 className="text-3xl md:text-4xl text-white mb-4 font-mono" data-id="element-288">
          LOGS DE{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-289">USUARIOS</span>
        </h2>
        <p className="text-gray-400 font-mono text-sm" data-id="element-290">
          {'//'} RESULTADOS VERIFICADOS EN LA MATRIX
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-291">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.2
      }} className="bg-cyber-dark border border-cyber-neon/40 rounded-lg p-6 relative group hover:border-cyber-neon hover:shadow-neon transition-all duration-300" data-id="element-292">
            {/* Decorative corner */}
            <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-cyber-neon rounded-tr-lg opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-293"></div>

            <MessageSquare className="text-cyber-purple w-6 h-6 mb-4 opacity-70" data-id="element-294" />

            <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-295">
              "{t.quote}"
            </p>

            <div className="mt-auto pt-4 border-t border-gray-800" data-id="element-296">
              <p className="text-white font-bold font-mono text-sm" data-id="element-297">{t.name}</p>
              <p className="text-gray-500 text-xs mb-3" data-id="element-298">
                {t.age} años | {t.location}
              </p>

              <div className="bg-cyber-neon/10 border border-cyber-neon/30 rounded px-3 py-2 flex items-start gap-2" data-id="element-299">
                <CheckCircle2 className="text-cyber-neon w-4 h-4 shrink-0 mt-0.5" data-id="element-300" />
                <p className="text-cyber-neon text-xs font-mono" data-id="element-301">
                  <span className="opacity-70" data-id="element-302">Resultado:</span> {t.result}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}